// extracted by mini-css-extract-plugin
module.exports = {"splashStyle":"PayNowOverview_splashStyle__gjuly"};